module.exports = {
      id: "759b31d505be37fb3d9af0348af52d10electricity-230v-400v.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#759b31d505be37fb3d9af0348af52d10electricity-230v-400v.svg",
      toString: function () {
        return this.url;
      }
    }